import * as React from "react";
import Card from "../ui/card";

// TODO replace secondary links without text by item.venue

function PressCardCompact({ item, options = {}, ...props } = {}) {
  const defaultOpts = {
    stretchMainLink: true,
    mainLinkText: "View",
    maxNumLinks: 1,
    showDate: true,
    showProperties: false,
    showDateInFooter: true,
  };
  const opts = { ...defaultOpts, ...options };
  return (
    <Card
      title={item.title}
      date={item.date}
      subtitle={item.venue}
      mainLink={item.fields.pagePath}
      options={opts}
      {...props}
    />
  );
}

export default PressCardCompact;
